module.exports = __webpack_public_path__ + "static/media/大连禁毒教育基地-min.9ebe51c7.jpg";